import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation Mutation($input: LoginInput!) {
    login(input: $input) {
      message
      statusCode
      data {
        id
        full_name
        email
        image
        phone
        role {
          id
          name
        }
        fcm_token
        is_active
        is_verified
        createdAt
        updatedAt
      }
      accessToken
      refreshToken
    }
  }
`;

export const REQUEST_PASSWORD = gql`
  mutation RequestPassowrd($input: RequestPasswordInput!) {
    requestPassowrd(input: $input) {
      message
      statusCode
      data
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation RequestVerify($input: RequestVerifyInput!) {
    requestVerify(input: $input) {
      message
      statusCode
      data
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResestPassword($input: ResetPasswordInput!) {
    resestPassword(input: $input) {
      message
      statusCode
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation Mutation($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      message
      statusCode
    }
  }
`;

export const GET_CUSTOMER = gql`
  mutation RequestPassowrd($input: RequestPasswordInput!) {
    requestPassowrd(input: $input) {
      message
      statusCode
      data
    }
  }
`;

export const ADD_CUSTOMER = gql`
  mutation CreateCustomer($input: CreateCustomersInput!) {
    createCustomer(input: $input) {
      message
      statusCode
    }
  }
`;

export const EDIT_CUSTOMER = gql`
  mutation Mutation($input: UpdateCustomersInput!) {
    updateCustomer(input: $input) {
      message
      statusCode
    }
  }
`;

export const ADD_BRANDS = gql`
  mutation Mutation($input: CreateBrandInput!, $image: Upload) {
    createBrand(input: $input, image: $image) {
      message
      statusCode
    }
  }
`;

export const EDIT_BRANDS = gql`
  mutation Mutation($input: UpdateBrandInput!, $image: Upload) {
    updateBrand(input: $input, image: $image) {
      message
      statusCode
    }
  }
`;

export const DELETE_BRAND = gql`
  mutation Mutation($deleteBrandId: Int!) {
    deleteBrand(id: $deleteBrandId) {
      message
      statusCode
    }
  }
`;

export const ADD_CATEGORY = gql`
  mutation CreateCategory($input: CreateCategoryInput!, $icon: Upload) {
    createCategory(input: $input, icon: $icon) {
      message
      statusCode
    }
  }
`;

export const EDIT_CATEGORY = gql`
  mutation Mutation($input: UpdateCategoryInput!, $icon: Upload) {
    updateCategory(input: $input, icon: $icon) {
      message
      statusCode
    }
  }
`;

export const ADD_SUPPLIER = gql`
  mutation CreateUser($input: CreateUserInput!, $image: Upload) {
    createUser(input: $input, image: $image) {
      message
      statusCode
    }
  }
`;

export const EDIT_SUPPLIER = gql`
  mutation Mutation($input: UpdateUserInput!, $image: Upload) {
    updateUser(input: $input, image: $image) {
      message
      statusCode
    }
  }
`;

export const CREATE_PRODUCTS = gql`
  mutation Mutation($input: CreateProductInput!) {
    createProduct(input: $input) {
      message
      statusCode
    }
  }
`;

export const UPDATE_PRODUCTS = gql`
  mutation Mutation($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      message
      statusCode
    }
  }
`;

export const CREATE_STORE = gql`
  mutation Mutation($input: CreateStoreInput!, $image: Upload!) {
    createStore(input: $input, image: $image) {
      message
      statusCode
    }
  }
`;

export const EDIT_STORE = gql`
  mutation UpdateStore($input: UpdateStoreInput!, $image: Upload) {
    updateStore(input: $input, image: $image) {
      message
      statusCode
    }
  }
`;

export const CREATE_UNIT = gql`
  mutation Mutation($input: CreateUnitInput!) {
    createUnit(input: $input) {
      message
      statusCode
    }
  }
`;

export const EDIT_UNIT = gql`
  mutation Mutation($input: UpdateUnitInput!) {
    updateUnit(input: $input) {
      message
      statusCode
    }
  }
`;

export const CREATE_WAREHOUSE = gql`
  mutation Mutation($input: CreateWarehouseInput!) {
    createWarehouse(input: $input) {
      message
      statusCode
    }
  }
`;

export const EDIT_WAREHOUSE = gql`
  mutation Mutation($input: UpdateWarehouseInput!) {
    updateWarehouse(input: $input) {
      message
      statusCode
    }
  }
`;

export const CREATE_QUOTATION = gql`
  mutation Mutation($input: CreateOrderInput!) {
    createOrder(input: $input) {
      message
      statusCode
    }
  }
`;

export const EDIT_QUOTAION = gql`
  mutation Mutation($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      message
      statusCode
    }
  }
`;

export const GENERATE_QUOTATION_PDF = gql`
  mutation GenerateOrderPDF($generateOrderPdfId: Int!) {
    generateOrderPDF(id: $generateOrderPdfId)
  }
`;

export const GENERATE_INVOICE = gql`
  mutation Mutation($generateSalePdfId: Int!) {
    generateSalePDF(id: $generateSalePdfId) {
      message
      statusCode
      data
    }
  }
`;

export const GENERATE_PACKING_LIST = gql`
  mutation Mutation($generatePackingPdfId: Int!) {
    generatePackingPDF(id: $generatePackingPdfId) {
      data
      message
      statusCode
    }
  }
`;

export const GENERATE_LEDGER = gql`
  mutation Mutation($customerId: Int!) {
    generateLedger(customer_id: $customerId) {
      data
      message
      statusCode
    }
  }
`;

export const CREATE_SALE = gql`
  mutation CreateSale($input: CreateSaleInput!) {
    createSale(input: $input) {
      data
      message
      statusCode
    }
  }
`;

export const EDIT_SALE = gql`
  mutation Mutation($input: UpdateSaleInput!) {
    updateSale(input: $input) {
      message
      statusCode
    }
  }
`;

export const CANCEL_SALE = gql`
  mutation Mutation($cancelSaleId: Int!) {
    cancelSale(id: $cancelSaleId) {
      message
      statusCode
    }
  }
`;

export const CREATE_PAYMENT = gql`
  mutation Mutation($input: CreatePaymentInput!) {
    createPayment(input: $input) {
      message
      statusCode
    }
  }
`;

export const UPDATE_PAYMENT = gql`
  mutation UpdatePayment($input: UpdatePaymentInput!) {
    updatePayment(input: $input) {
      message
      statusCode
    }
  }
`;

export const DELETE_PAYMENT = gql`
  mutation DeletePayment($deletePaymentId: Int!) {
    deletePayment(id: $deletePaymentId) {
      message
      statusCode
    }
  }
`;

export const UPDATE_PRODUCT_STATUS = gql`
  mutation UpdateProductStatus($updateProductStatusId: Int!) {
    updateProductStatus(id: $updateProductStatusId) {
      message
      statusCode
    }
  }
`;

export const CREATE_SALE_RETURN = gql`
  mutation Mutation($input: CreateSaleReturnInput!) {
    createSaleReturn(input: $input) {
      data
      message
      statusCode
    }
  }
`;

// export const EDIT_PRODUCTS = gql`
//   mutation Mutation($input: UpdateProductInput!) {
//     updateProduct(input: $input) {
//       message
//       statusCode
//     }
//   }
// `;
